* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: 'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;
  background-color: #F6F8FB;
  color: #182235;
  overflow-x: hidden;
}
button,
select,
input {
  font-family: inherit;
}

button,
select,
summary {
  -webkit-tap-highlight-color: transparent;
}

canvas {
  max-width: 100%;
}

@media (max-width: 760px) {
  .intro-panel {
    grid-template-columns: 1fr !important;
  }

  .control-panel,
  .metrics-panel,
  .explanation-panel,
  .code-panel {
    padding: 16px !important;
  }
}

@media (max-width: 420px) {
  .property-row {
    grid-template-columns: 1fr !important;
  }
}
